<template>
  <div class="visual-id-box"
    :class="{link: !!this.to}"
    @click="goToPage(); download()"
  >
    <img :src="visualIdBox && '/images/vi/' + visualIdBox" />
    <p :class="!title && 'noTitle'" v-html="title" />
    <div class="darkerHover"></div>
  </div>
</template>

<script>
export default {
  name: 'VisualIdBox',
  props: ['title', 'visualIdBox', 'to', 'url'],
  methods: {
    download() {
      if (this.url) {
        window.open(this.url);
      }
    },
    goToPage() {
      if (this.to) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .visual-id-box
    position: relative
    display: flex
    justify-content: center
    align-items: flex-end
    height: 25rem
    width: 25rem
    cursor: pointer

    img
      width: 90%
      height: 90%

      &:hover
        margin-bottom: 2rem
        transition: 0.2s

    p
      position: absolute
      bottom: 0
      width: 105%
      margin: 0
      padding: 1.2rem 0
      font-weight: 700
      text-align: center
      text-transform: uppercase
      background-color: $green60
      color: $white
      border-radius: 0.3rem
      z-index: 2

    .noTitle
      display: none

  .visual-id-box:last-of-type

    img
      &:hover
        margin-bottom: 0

</style>
